import(/* webpackMode: "eager" */ "/www/wwwroot/mastermindevent.id/mastermind-next/app/error.tsx")